import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import styles from './Accordion.module.css';

function Accordion({ title, children, defaultOpen = false, onEdit }) {
  const [open, setOpen] = useState(defaultOpen);

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      setOpen(o => !o);
    }
  };

  return (
    <div className={styles.accordionContainer}>
      <div
        onClick={() => setOpen(o => !o)}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex="0"
        className={styles.accordionHeader}
        aria-expanded={open}
      >
        <div className={styles.accordionTitleGroup}>
          <span>{title}</span>
          <span>{open ? '▲' : '▼'}</span>
        </div>
      </div>

      {open && onEdit && (
        <button
          type="button"
          onClick={onEdit}
          className={styles.accordionButton}
        >
          <FontAwesomeIcon icon={faPenToSquare} /> Edit
        </button>
      )}
      
      {open && <div className={styles.accordionChildren}>{children}</div>}
    </div>
  );
};

export default Accordion;